import {useEffect, useState} from "react";

function Toggle({title, value, setValue, initialError, updateObject, id, values = ["Oui", "Non"], required}) {
    const [error, setError] = useState(initialError);
    useEffect(() => {setError(initialError);}, [initialError]);

    function handleChange(event) {
        if (typeof setValue === 'function') {
            setValue(event.target.checked);
        }

        if (typeof updateObject === 'function') {
            updateObject(id, event.target.checked);
        }
    }

    return (
        <div>
            <div className="block font-medium p-1 mb-2">{title}{required ? "*" : ""}</div>
            <label htmlFor={id} className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" value={value} required={required} className="sr-only peer"
                       onChange={handleChange} name={id} id={id} checked={value} />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-light
                                        rounded-full peer peer-checked:after:translate-x-full
                                        peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px]
                                        after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all
                                        peer-checked:bg-primary-light"></div>
                <span className="ml-3 text-sm font-medium text-gray-900">{value ? values[0] : values[1]}</span>
            </label>
            {error ?
                (
                    <p className="mt-0 text-xs text-red-600 font-medium">{error}</p>
                )
                : ""}
        </div>
    );
}

export default Toggle;